// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2njZ7","errorLogs":"styles_errorLogs__2L82e"};